import ApiService from '@/common/api.service'

const RESOURCE = 'user'
const UserService = {
  post (params) {
    return ApiService.post(RESOURCE, params)
  },
  updateProfile (params) {
    return ApiService.updateResource(`${RESOURCE}/profile`, params)
  },
  getMailChangeAddress (params) {
    return ApiService.query(`${RESOURCE}/mail/change/address`, params)
  },
  getMail (params) {
    return ApiService.query(`${RESOURCE}/mail`, params)
  },
  updateMail (params) {
    return ApiService.updateResource(`${RESOURCE}/mail`, params)
  },
  login (params) {
    return ApiService.post(`${RESOURCE}/login`, params)
  }
}
export default UserService
